"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var firebase = _interopRequireWildcard(require("firebase/app"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = require("../utils");

var _runtime = _interopRequireWildcard(require("../utils/runtime"));

var _compatibility = require("../compatibility");

var _transport = require("../transport");

var _constants = require("../constants");

var _path = require("../utils/path");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 管理 firebase 统计渠道的网络性能
function init() {
  (0, _utils.tryCall)(function () {
    return reportNetworkNavigation();
  }, false);
} // 借由统计首个doc的加载性能，量化用户的网络性能
// 不统计前进后退等可能直接加载本地缓存的场景


function reportNetworkNavigation() {
  // 加载行为检查，确保是加载或刷新
  if (performance.navigation.type !== 0 && performance.navigation.type !== 1) {
    // https://developer.mozilla.org/zh-CN/docs/Web/API/PerformanceNavigation
    return false;
  }

  var navigationEntry = (0, _utils.tryCall)(function () {
    return performance.getEntriesByType('navigation')[0];
  });
  var metrics = parseTimingObjectToNetwork(performance.timing);
  var n = (0, _runtime.isOfflineEnv)() ? 'off_network_navigation' : 'network_navigation';
  (0, _transport.transport)({
    endPoints: [_constants.FIREBASE_ENDPOINT_NAME, _constants.PROMETHEUS_ENDPOINT_NAME],
    type: n,
    traceName: n,
    url: (0, _path.getUrl)(),
    message: {
      metrics: _objectSpread({
        duration: metrics.total_wait
      }, _lodash.default.pickBy(_objectSpread({}, _lodash.default.omit(metrics, 'total_wait'), {
        transfer_size: (0, _utils.safeComputeInteger)(function () {
          return navigationEntry && navigationEntry.transferSize / 1024;
        })
      }), _lodash.default.isFinite)),
      attributes: {
        navigation_type: performance.navigation.type + '',
        pathname: location.pathname,
        protocol: navigationEntry && navigationEntry.nextHopProtocol || '',
        is_https: location.protocol === 'https' ? ' true' : 'false',
        no_download: metrics.download === 0 ? 'true' : 'false'
      }
    }
  }); // 标记统计成功

  return true;
} // API定义  https://developer.mozilla.org/zh-CN/docs/Web/API/PerformanceTiming
// 基本原理  https://blog.51cto.com/shuizhongyue/1718327
// 各字段完整描述见  https://www.cnblogs.com/btgyoyo/p/6341077.html


function parseTimingObjectToNetwork(timingObject) {
  var metrics = {}; // 总等待时长

  metrics.total_wait = (0, _utils.safeComputeInteger)(function () {
    return timingObject.responseEnd - timingObject.navigationStart;
  }); // 等待重定向时间。未重定向时为0

  metrics.redirect = (0, _utils.safeComputeInteger)(function () {
    return timingObject.redirectEnd - timingObject.redirectStart;
  }); // DNS查询。本地复用缓存时为0

  metrics.dns = (0, _utils.safeComputeInteger)(function () {
    return timingObject.domainLookupEnd - timingObject.domainLookupStart;
  }); // TCP连接和SSL连接

  if (timingObject.secureConnectionStart === 0) {
    metrics.tcp = (0, _utils.safeComputeInteger)(function () {
      return timingObject.connectEnd - timingObject.connectStart;
    });
    metrics.ssl = 0;
  } else {
    metrics.tcp = (0, _utils.safeComputeInteger)(function () {
      return timingObject.secureConnectionStart - timingObject.connectStart;
    });
    metrics.ssl = (0, _utils.safeComputeInteger)(function () {
      return timingObject.connectEnd - timingObject.secureConnectionStart;
    });
  } // TTFB


  metrics.ttfb = (0, _utils.safeComputeInteger)(function () {
    return timingObject.responseStart - timingObject.requestStart;
  }); // 响应时间，TTFB至内容下载完成

  metrics.download = (0, _utils.safeComputeInteger)(function () {
    return timingObject.responseEnd - timingObject.responseStart;
  }); // 总网络消耗时间（redirect之后，至请求结束），不含 redirect/dom 处理时间

  metrics.pure_network = (0, _utils.safeComputeInteger)(function () {
    return timingObject.responseEnd - timingObject.fetchStart;
  }); // 返回

  return metrics;
}